import {CaseItemStatus} from '@modules/cases/models/Statuses';

export class CaseItem {
  constructor(
    public masterId: string,
    public entryId: string,
    public creationTime: string,
    public updateTime: string,
    public currentVersion: number,
    public caseClass: string,
    public name: string,
    public typeLocked: boolean,
    public type: string,
    public presignedUrls: any,
    public s3Objects: any[],
    public serviceStatuses: any,
    public retriesPerPage: any,
    public status: CaseItemStatus,
    public recognisedData: {},
    public confirmedData: {},
    public review: boolean,
    public maxRetries: number,
    public main: boolean
  ) {}
}
